import * as yup from "yup";

const schema = yup.object().shape({
  name: yup.string().required("Введите название"),
  fiasAddressId: yup
    .string()
    .required("Выберите адрес из списка")
    .test("fiasAddressId", "failureMessage", function (val) {
      if (val === "00000000-0000-0000-0000-000000000000") {
        return this.createError({
          message: "Сотрите адрес и выберите снова",
        });
      }
      return true;
    }),
  organizationMainId: yup
    .number()
    .typeError("Выберите организацию")
    .required("Выберите организацию"),
  ownershipTypeId: yup
    .number()
    .typeError("Выберите вид собственности")
    .required("Выберите вид собственности"),
  funcTypeGroupId: yup.mixed().required("Выберите группу"),
  startExplYear: yup.mixed().required("Выберите год"),
  totalArea: yup
    .string()
    .test("totalArea", function (val) {
      const valZero = val.length ? val.replace(/0/g, "") : true;
      if (!valZero) {
        return this.createError({
          message: "Введите целое число",
        });
      }
      if (val.length && val.split(".")[0].length >= 9) {
        return this.createError({
          message: "проверьте корректность вводимого значение",
        });
      }
      if (val.length && val.split(".")[1]?.length > 2) {
        return this.createError({
          message: "проверьте корректность вводимого значение",
        });
      }
      return true;
    })
    .required("Введите площадь"),
  effectiveArea: yup
    .string()
    .test("effectiveArea", function (val) {
      const valZero = val.length ? val.replace(/0/g, "") : true;
      if (!valZero) {
        return this.createError({
          message: "Введите целое число",
        });
      }
      if (val.length && val.split(".")[0].length >= 9) {
        return this.createError({
          message: "проверьте корректность вводимого значение",
        });
      }
      if (val.length && val.split(".")[1]?.length > 2) {
        return this.createError({
          message: "проверьте корректность вводимого значение",
        });
      }
      return true;
    })
    .required("Введите площадь"),
  heatedArea: yup
    .string()
    .test("heatedArea", function (val) {
      const valZero = val.length ? !val.replace(/0/g, "") : true;
      if (valZero) {
        return true;
      }
      if (val.length && val.split(".")[0].length >= 9) {
        return this.createError({
          message: "проверьте корректность вводимого значение",
        });
      }
      if (val.length && val.split(".")[1]?.length > 2) {
        return this.createError({
          message: "проверьте корректность вводимого значение",
        });
      }
      return true;
    })
    .required("Введите площадь"),
});

export default schema;
